




































import { MDAUserService } from '@/api/com/MetaPattern/APP/MDA/User/MDAUserService';
import { IDEContext } from '@/libs/com/MetaPattern/Product/IDE/IDEContext';
import { ValidateHelper } from '@/libs/com/MetaPattern/Product/IDE/Util/ValidateHelper';
import { Component, Vue, Watch } from 'vue-property-decorator';

class UserInitInfo {
  workScopeName: string;
  workScopeDisplayName: string;
  gitUrl: string;
  gitUsername: string;
  gitPassword: string;
  gitBranch: string;
}

@Component({
  components: {
  }
})
export default class UserInit extends Vue {
  private initForm: UserInitInfo;

  constructor() {
    super();
    this.initForm = new UserInitInfo();
  }

  validateName(rule: any, value: string, callback: any) {
    ValidateHelper.validateExpressWithCallback('^[a-zA-Z]{1}[a-zA-Z0-9]{5,15}$', '名称必须至少6位且包含字母和数字，以字母开头，最长16位', value, callback);
  }

  confirm() {
    (this.$refs.initForm as any).validate((valid: any) => {
      if (valid) {
        const loadingText = '正在努力执行，初始化操作需要克隆系统应用并提交到您指定的GIT地址。这个操作需要几分钟，请耐心等待...';
        const loading = this.$loading({
          lock: true,
          text: loadingText,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        MDAUserService.UserInitAsync(this.initForm.workScopeName, this.initForm.workScopeDisplayName, this.initForm.gitUrl, this.initForm.gitBranch, this.initForm.gitUsername, this.initForm.gitPassword)
          .then(res => {
            if (res) {
              // 初始化以后，要重新获取所有的配置
              IDEContext.instance.getUserInfoAsync(IDEContext.instance.curAccountInfo.accountId, IDEContext.instance.curUser.id)
                .then(() => {
                  loading.close();
                  this.$router.push('/LoginInit');
                })
                .catch(error => {
                  console.log(error);
                  this.$message({ type: 'error', message: '初始化失败!原因是：' + error });
                  loading.close();
                });
            } else {
              console.log(res);
              this.$message({ type: 'error', message: '初始化失败!' });
              loading.close();
            }
          })
          .catch(error => {
            console.log(error);
            this.$message({ type: 'error', message: '初始化失败!原因是：' + error });
            loading.close();
          });
      }
      return false;
    });
  }

  cancel() {
    (this.$refs.initForm as any).resetFields();
  }

  get labelWidth() {
    return '120px';
  }
}
